export class TopMenuData {
  public id: number
  public name: string
  public key: string
  public value: string
  public icon: string
  public color: string
  constructor(
    id: number,
    name: string,
    key: string,
    value: string,
    icon: string,
    color: string
  ) {
    {
      this.id = id
      this.name = name
      this.key = key
      this.value = value
      this.icon = icon
      this.color = color
    }
  }
}
export class ChartData {
  public value: number
  public dealerCode: string
  public dealerName: string
  public dealerCity: string
  constructor(
    value: number,
    dealerCode: string,
    dealerName: string,
    dealerCity: string
  ) {
    {
      this.value = value
      this.dealerCode = dealerCode
      this.dealerName = dealerName
      this.dealerCity = dealerCity
    }
  }
}

export class ChartDataDealer {
  public value: number
  public name: string
  constructor(value: number, name: string) {
    {
      this.value = value
      this.name = name
    }
  }
}
export class TableDealer {
  public id: number
  public salesmancode: string
  public salesmanname: string
  public possition: string
  public lastAccess: number
  constructor(
    id: number,
    salesmancode: string,
    salesmanname: string,
    possition: string,
    lastAccess: number
  ) {
    {
      this.id = id
      this.salesmancode = salesmancode
      this.salesmanname = salesmanname
      this.possition = possition
      this.lastAccess = lastAccess
    }
  }
}
export class UserActiveData {
  public id: number
  public dealerCode: string
  public dealerName: string
  public dealerCity: string
  public dealerGroup: string
  public totalAccess: number
  constructor(
    id: number,
    dealerCode: string,
    dealerName: string,
    dealerCity: string,
    dealerGroup: string,
    totalAccess: number
  ) {
    {
      this.id = id
      this.dealerCode = dealerCode
      this.dealerName = dealerName
      this.dealerCity = dealerCity
      this.dealerGroup = dealerGroup
      this.totalAccess = totalAccess
    }
  }
}
export class CategoryMaterialsData {
  public id: number
  public title: string
  public categoryMaterial: string
  public totalVisit: number
  public totalUser: number
  constructor(
    id: number,
    title: string,
    categoryMaterial: string,
    totalVisit: number,
    totalUser: number
  ) {
    {
      this.id = id
      this.title = title
      this.categoryMaterial = categoryMaterial
      this.totalVisit = totalVisit
      this.totalUser = totalUser
    }
  }
}

export class Dashboard {
  public success: boolean
  public message: string
  public topMenuData?: TopMenuData[]
  public chartData?: ChartData[]
  public chartDealerNotAccessed?: ChartDataDealer[]
  public chartDealerUnregister?: ChartDataDealer[]
  public userDealerUnregister?: TableDealer[]
  public userDealerNotAccessed?: TableDealer[]
  public userActiveData?: UserActiveData[]
  public categoryMaterialsData?: CategoryMaterialsData[]

  constructor(
    success: boolean,
    message: string,
    topMenuData?: TopMenuData[],
    chartData?: ChartData[],
    chartDealerNotAccessed?: ChartDataDealer[],
    chartDealerUnregister?: ChartDataDealer[],
    userDealerUnregister?: TableDealer[],
    userDealerNotAccessed?: TableDealer[],
    userActiveData?: UserActiveData[],
    categoryMaterialsData?: CategoryMaterialsData[]
  ) {
    this.success = success
    this.message = message
    this.topMenuData = topMenuData
    this.chartData = chartData
    this.chartDealerNotAccessed = chartDealerNotAccessed
    this.chartDealerUnregister = chartDealerUnregister
    this.userDealerUnregister = userDealerUnregister
    this.userDealerNotAccessed = userDealerNotAccessed
    this.userActiveData = userActiveData
    this.categoryMaterialsData = categoryMaterialsData
  }
}
